import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export function GetWorksdaysType(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/enumlist/workingdaystype`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      onError(error);
    });
}

export function CreateAdditionalholidays(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  additionalholidaysObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/configpublicholiday/additionalholidays`,
      additionalholidaysObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      onError(error);
    });
}

export function DeleteAdditionalholidays(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  additionalholidayId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/configpublicholiday/additionalholidays/${additionalholidayId}`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      onError(error);
    });
}

export function UpdateAdditionalholidays(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  additionalholidaysObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/configpublicholiday/additionalholidays/${
          additionalholidaysObject.id
        }`,
      additionalholidaysObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      onError(error);
    });
}

export function GetAdditionalholidays(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/configpublicholiday/additionalholidays`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      onError(error);
    });
}

export function GetPublicholidayConfig(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/configpublicholiday`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      onError(error);
    });
}

export function CreatePublicholidayConfig(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  publicholidayObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/configpublicholiday`,
      publicholidayObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      onError(error);
    });
}

export function UpdatePublicholidayConfig(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  publicholidayObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/configpublicholiday`,
      publicholidayObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      onError(error);
    });
}
